import { getImageResizes } from '@sky-it-livedata-libraries/livedata-commons';

const allSizes = {
  '1x': 220,
  '2x': 440,
};

export const fallbackPlayerImages = () => {
  const footballTeam = document.querySelector('.ftbl__team-tabs-wrapper__tabs');
  const playerImages = footballTeam?.querySelectorAll<HTMLImageElement>('.ftbl__player-card__image > img');

  playerImages?.forEach((img: HTMLImageElement) => {
    handleImageCurrent(img);
  });
};

const handleImageCurrent = (img: HTMLImageElement) => {
  const imageCurrent = new Image();
  imageCurrent.src = img.src;

  imageCurrent.onerror = () => {
    const fallback = img.getAttribute('data-src-fallback');
    if (fallback) {
      handleImageFallback(img, fallback);
    } else {
      handleImagePlaceholder(img);
    }
  };

  imageCurrent.onload = () => {
    const imgUrl = img.src;
    img.src = getImageResizes({ fileName: imgUrl, sizes: { '1x': allSizes['1x'] } });
    img.srcset = getImageResizes({ fileName: imgUrl, sizes: allSizes });
    return true;
  };
};

const handleImageFallback = (img: HTMLImageElement, fallback: string): void | Error => {
  const imageFallback = new Image();
  imageFallback.src = fallback;
  imageFallback.onerror = () => {
    handleImagePlaceholder(img);
  };

  imageFallback.onload = () => {
    img.src = getImageResizes({ fileName: fallback, sizes: { '1x': allSizes['1x'] } });
    img.srcset = getImageResizes({ fileName: fallback, sizes: allSizes });
  };
};
const handleImagePlaceholder = (img: HTMLImageElement) => {
  const placeholder = img.getAttribute('data-src-placeholder');
  if (placeholder) {
    img.src = placeholder;
  }
};
